import * as React from "react";
import { EventCardProps } from "../..";
import { MarketTemplate } from "../../../../../data";
import { prepareEmptyMarket } from "../../../../../helpers";
import { renderOutrightBetButtons } from "./renderOutrightBetButtons";

export const renderOutrightMarkets = (cardProps: EventCardProps, buttonsHolderClass: string, componentPrefix: string) => {
    const market = cardProps.markets.length > 0
        ? cardProps.markets[0]
        : prepareEmptyMarket(cardProps, MarketTemplate.ThreeBox, 0);

    const marketConfig = cardProps.sport.config.outrightMarkets.find((mconfig) => mconfig.idLive === market.id);
    market.template = marketConfig ? marketConfig.template : MarketTemplate.ThreeBox;
    return (
        <div key={`${componentPrefix}__buttons-holder__${cardProps.event.id}`} className={`rj-ev-list__${componentPrefix}__buttons-holder ${buttonsHolderClass}`} data-uat={`div-ev-list-${componentPrefix}-buttons-holder`}>
            {renderOutrightBetButtons(market, cardProps.handlers.betButton, componentPrefix)}
        </div>
    );
};